import { requestFeedback, withActionFeedback, type RequestFeedback } from './action-feedback-store';
export type User={id:string;username:string;fullName:string;roles:string[];permissions?:string[];permissionScopes?:Record<string,string>};
export type ApiOptions = RequestInit & { feedback?: RequestFeedback | false };
declare global {
  interface Window {
    PhuocHaoTv?: { setKioskEnabled(enabled: boolean): void };
  }
}
let accessToken:string|null=null;
let refreshInFlight:Promise<string|null>|null=null;
export const setAccessToken=(token:string|null)=>{accessToken=token};
export const getAccessToken=()=>accessToken;
function refreshAccess(){
  if(!refreshInFlight)refreshInFlight=(async()=>{
    const response=await fetch('/api/auth/refresh',{method:'POST',credentials:'include'});
    if(!response.ok)return null;
    const session=await response.json();setAccessToken(session.accessToken);return session.accessToken as string;
  })().finally(()=>{refreshInFlight=null});
  return refreshInFlight;
}

async function apiResponse(path:string,options:RequestInit={}):Promise<Response>{
  const headers=new Headers(options.headers);if(options.body&&!(options.body instanceof FormData)&&!headers.has('Content-Type'))headers.set('Content-Type','application/json');if(accessToken)headers.set('Authorization',`Bearer ${accessToken}`);
  let response=await fetch(`/api${path}`,{...options,headers,credentials:'include'});
  if(response.status===401&&path!=='/auth/refresh'&&path!=='/auth/login'){
    const updated=accessToken&&headers.get('Authorization')!==`Bearer ${accessToken}`?accessToken:await refreshAccess();
    if(updated){headers.set('Authorization',`Bearer ${updated}`);response=await fetch(`/api${path}`,{...options,headers,credentials:'include'});}
  }
  if(!response.ok){const error=await response.json().catch(()=>({message:'Không thể kết nối máy chủ.'}));throw new Error(error.message||'Có lỗi xảy ra.');}
  return response;
}
function feedbackOptions(path: string, options: ApiOptions) {
  const { feedback, ...request } = options;
  return { request, messages: feedback === undefined ? requestFeedback(path, (request.method || 'GET').toUpperCase()) : feedback };
}
function networkError(error: unknown, mutating: boolean): never {
  if (error instanceof TypeError) throw new Error(mutating ? 'Mất kết nối: chưa nhận được xác nhận từ máy chủ. Kiểm tra dữ liệu trước khi gửi lại để tránh thao tác trùng.' : 'Không thể kết nối máy chủ. Kiểm tra mạng và thử lại.');
  throw error;
}
export async function api<T=any>(path:string,options:ApiOptions={}):Promise<T>{
  const { request, messages } = feedbackOptions(path, options);
  return withActionFeedback(async () => {
    try {
      const response=await apiResponse(path,request);
      if (response.status===204) return undefined as T;
      try { return await response.json(); }
      catch (error) { if ((error as Error)?.name === 'AbortError') throw error; throw new Error('Không đọc được xác nhận từ máy chủ. Kiểm tra dữ liệu trước khi gửi lại.'); }
    } catch (error) { return networkError(error, !['GET','HEAD'].includes((request.method || 'GET').toUpperCase())); }
  }, messages);
}
export async function apiBlob(path:string,options:ApiOptions={}):Promise<Blob>{
  const { request, messages } = feedbackOptions(path, options);
  return withActionFeedback(async () => { try { return await (await apiResponse(path,request)).blob(); } catch (error) { return networkError(error, false); } }, messages);
}

export const post=<T=any>(path:string,data:unknown={},options:Omit<ApiOptions,'method'|'body'>={})=>api<T>(path,{...options,method:'POST',body:JSON.stringify(data)});
export function urlBase64ToUint8Array(value:string){const padding='='.repeat((4-value.length%4)%4);const base64=(value+padding).replace(/-/g,'+').replace(/_/g,'/');return Uint8Array.from(atob(base64),c=>c.charCodeAt(0));}
